var map = {
	"./template.bet575": 1087,
	"./template.bet575.tsx": 1087,
	"./template.bet777": 1088,
	"./template.bet777.tsx": 1088,
	"./template.betgalaxy": 1089,
	"./template.betgalaxy.tsx": 1089,
	"./template.betprofessor": 2117,
	"./template.betprofessor.tsx": 2117,
	"./template.betroyale": 2118,
	"./template.betroyale.tsx": 2118,
	"./template.betstride": 1090,
	"./template.betstride.tsx": 1090,
	"./template.buffalobet": 2119,
	"./template.buffalobet.tsx": 2119,
	"./template.chromabet": 1091,
	"./template.chromabet.tsx": 1091,
	"./template.default": 658,
	"./template.default.tsx": 658,
	"./template.epicodds": 2120,
	"./template.epicodds.tsx": 2120,
	"./template.fiestabet": 2121,
	"./template.fiestabet.tsx": 2121,
	"./template.forsport": 1092,
	"./template.forsport.tsx": 1092,
	"./template.gigabet": 2122,
	"./template.gigabet.tsx": 2122,
	"./template.goldenbet888": 2017,
	"./template.goldenbet888.tsx": 2017,
	"./template.goldenrush": 2123,
	"./template.goldenrush.tsx": 2123,
	"./template.hyperbet": 1093,
	"./template.hyperbet.tsx": 1093,
	"./template.juicybet": 2124,
	"./template.juicybet.tsx": 2124,
	"./template.junglebet": 2125,
	"./template.junglebet.tsx": 2125,
	"./template.magnumbet": 1094,
	"./template.magnumbet.tsx": 1094,
	"./template.oldgill": 1095,
	"./template.oldgill.tsx": 1095,
	"./template.puntcity": 1096,
	"./template.puntcity.tsx": 1096,
	"./template.puntgenie": 1097,
	"./template.puntgenie.tsx": 1097,
	"./template.pyramidbet": 1098,
	"./template.pyramidbet.tsx": 1098,
	"./template.questbet": 1099,
	"./template.questbet.tsx": 1099,
	"./template.slambet": 2126,
	"./template.slambet.tsx": 2126,
	"./template.sterlingparker": 2127,
	"./template.sterlingparker.tsx": 2127,
	"./template.sugarcastle": 1100,
	"./template.sugarcastle.tsx": 1100,
	"./template.templebet": 2128,
	"./template.templebet.tsx": 2128,
	"./template.titanbet": 2129,
	"./template.titanbet.tsx": 2129,
	"./template.ts": 88,
	"./template.vikingbet": 1101,
	"./template.vikingbet.tsx": 1101,
	"./template.volcanobet": 1102,
	"./template.volcanobet.tsx": 1102,
	"./template.wellbet": 2130,
	"./template.wellbet.tsx": 2130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2425;